import React, { FC } from 'react'
import s from './DailyCard.module.sass'
import CardTwoBlock from '@shared/ui/Layout/CardTwoBlock/CardTwoBlock'
import { Text } from '@shared/ui/Typography/Text'
import IconDaily from '@icons/icon-afisha-daily-white.svg'
import Link from 'next/link'

interface Props {
  title: string
  url: string
  img: string
}

const DailyCard: FC<Props> = ({ title, url, img }) => {
  return (
    <CardTwoBlock sizes={'L ML'} href={url}>
      <CardTwoBlock.Img img={img} classNameWrapper={s.img} alt={`Изображение: ${title}`}>
        <IconDaily className={s.logo} />
      </CardTwoBlock.Img>
      <CardTwoBlock.Content>
        <Link href={url}>
          <Text sizes={'ML M'}>{title}</Text>
        </Link>
      </CardTwoBlock.Content>
    </CardTwoBlock>
  )
}

export default DailyCard
